import { c as _c } from "react/compiler-runtime";
import { registerCursorTracker } from 'cleave-zen';
import { useCallback, useEffect, useRef } from 'react';
import { applyDateEdit, formatValue, type MaskConfig } from '../utils/mask-utils';
const isDateMask = (config?: MaskConfig): boolean => !!config && 'date' in config && config.date === true;

/**
 * Hook for handling input masking with cleave-zen
 */
export const useInputMask = config => {
  const $ = _c(16);
  const inputRef = useRef(null);
  const previousValueRef = useRef(null);
  let t0;
  if ($[0] !== config) {
    t0 = value => formatValue(value, config);
    $[0] = config;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const formatInputValue = t0;
  let t1;
  if ($[2] !== config || $[3] !== formatInputValue) {
    t1 = event => {
      const input = event.currentTarget;
      const previousValue = previousValueRef.current;
      const {
        inputType
      } = event.nativeEvent as InputEvent;
      const edit = isDateMask(config) && previousValue !== null ? applyDateEdit({
        previousValue,
        rawValue: input.value,
        caret: input.selectionStart ?? 0,
        isForward: inputType === "deleteContentForward"
      }, config) : null;
      const formattedValue = edit ? edit.value : formatInputValue(input.value);
      if (formattedValue !== input.value) {
        input.value = formattedValue;
      }
      if (edit) {
        input.setSelectionRange(edit.caret, edit.caret);
      }
      previousValueRef.current = formattedValue;
    };
    $[2] = config;
    $[3] = formatInputValue;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const handleChange = t1;
  let t2;
  let t3;
  if ($[5] !== formatInputValue) {
    t2 = () => {
      if (!inputRef.current) {
        return;
      }
      previousValueRef.current = formatInputValue(inputRef.current.value);
    };
    t3 = [formatInputValue];
    $[5] = formatInputValue;
    $[6] = t2;
    $[7] = t3;
  } else {
    t2 = $[6];
    t3 = $[7];
  }
  useEffect(t2, t3);
  let t4;
  if ($[8] !== config) {
    t4 = () => {
      if (!inputRef.current || !config) {
        return;
      }
      if (isDateMask(config)) {
        return;
      }
      const input_0 = inputRef.current;
      const cursorTrackerDestructor = registerCursorTracker({
        input: input_0,
        delimiters: "delimiters" in config ? config.delimiters : [],
        delimiter: "delimiter" in config ? config.delimiter : "",
        prefix: "prefix" in config ? config.prefix : ""
      });
      return () => {
        cursorTrackerDestructor();
      };
    };
    $[8] = config;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== config || $[11] !== formatInputValue) {
    t5 = [config, formatInputValue];
    $[10] = config;
    $[11] = formatInputValue;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  useEffect(t4, t5);
  let t6;
  if ($[13] !== formatInputValue || $[14] !== handleChange) {
    t6 = {
      inputRef,
      handleChange,
      formatValue: formatInputValue
    };
    $[13] = formatInputValue;
    $[14] = handleChange;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
};